import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import { AxiosInstance } from "../../../../axios";
import { R_PER_PAGE } from "../../../../labels";
import { styled } from "@mui/material/styles";
import DatePickerSample from "../../DatePicker";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { AddCircleRounded, RemoveCircleRounded } from "@mui/icons-material";
import Loader from "../../Loader";

function AdmissionPurchase(props) {
  //usestate
  const moment = require("moment-timezone");
  const [rows, setRows] = useState([]);
  const txtBSearch = useRef(null); //search icon
  const location = useLocation();
  const { fillStatus, fillType, fillDate, fillSection, fillSearch } =
    location.state || {};
  let page = R_PER_PAGE;

  // use state
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [isLoading, setIsLoading] = useState(false);
  const [updateListData, setUpdateListData] = useState([]);
  const [totalSection, setTotalSection] = useState([]);
  const [isOpen, setIsOpen] = useState({
    status: false,
    startDate: false,
    section: false,
    category: false,
    due_date: false,
  });
  const [appData, setAppData] = useState({
    FDate: "",
    TDate: "",
    Days: "",
    name: "",
  });

  const [DueData, setDueData] = useState({
    FDate: "",
    TDate: "",
    Days: "",
    name: "",
  });

  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;

  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("UserId Not available");
  }

  const [updateChipData, setUpdateChipData] = useState([]);

  const [status, setStatus] = useState([]);
  const [appOn, setAppOn] = useState([]);
  const [appOnDue, setAppOnDue] = useState([]);
  const [typeOn, setTypeOn] = useState([]);
  const [section, setSection] = useState([]);

  let filterStatus = [];
  let filterType = [];
  let filterApplyed = [];
  let filterSearch = [];
  let filtersection = [];

  let filterDueDate = [];

  // filter useEffect

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    filterStatus = status;
  }, [status]);

  useEffect(() => {
    filtersection = section;
  }, [section]);

  useEffect(() => {
    filterType = typeOn;
  }, [typeOn]);

  useEffect(() => {
    filterApplyed = appOn;
  }, [appData]);

  useEffect(() => {
    filterDueDate = appOnDue;
  }, [DueData]);

  useEffect(() => {
    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }, [searchTerm]);

  useEffect(() => {
    if (fillStatus && fillStatus.length > 0) {
      setStatus(fillStatus);
      filterStatus = fillStatus;
    }
    if (fillDate && fillDate.length > 0) {
      setAppOn(fillDate);
      filterApplyed = fillDate;
    }
    if (fillType && fillType.length > 0) {
      setTypeOn(fillType);
      filterType = fillType;
    }
    if (fillSection && fillSection.length > 0) {
      setSection(fillSection);
      filtersection = fillSection;
    }
    if (fillSearch && fillSearch.length > 0) {
      setSearchTerm(fillSearch);
      if (fillSearch.length > 0) {
        filterSearch = [{ name: "" + fillSearch, type: "search" }];
      } else {
        filterSearch = [];
      }
    }
  }, []);

  useEffect(() => {
    if (props.tabChange) {
      handleAllClear();
      props.setTabChange(false);
    }
  }, [props.tabChange]);

  useEffect(() => {
    loadChipdata();
  }, []);

  useEffect(() => {
    if (props.activeTab === 2) {
      loadListdata();
    }
  }, [props.activeTab]);

  useEffect(() => {
    loadListdata();
  }, [updateChipData]);

  function updateStateData() {
    filterStatus = status;
    filterType = typeOn;
    filterApplyed = appOn;
    filtersection = section;

    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }

  //sorting function

  const handleSort = (event, sortKey) => {
    event.preventDefault();
    let order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
    let sortedList = updateListData.sort((a, b) => {
      if (a[sortKey] < b[sortKey]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[sortKey] > b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    setUpdateListData(sortedList);
  };

  // filter checkbox update
  const handleCheckboxChange = (event, names, typename) => {
    const { value, checked, name } = event.target;
    if (
      name === "Upcoming" ||
      name === "Ongoing" ||
      name === "Completed" ||
      name === "WaitForApproval" ||
      name === "Rejected" ||
      name === "Approved" ||
      name === "OnHold"
    ) {
      if (checked) {
        setStatus([...status, { id: value, name: name, type: "status" }]);
      } else {
        setStatus(status.filter((item) => item.id !== value));
      }
    } else if (
      name === "course" ||
      name === "TestBatch" ||
      name === "SpecialClass" ||
      name === "Counselling" ||
      name === "MockInterview" ||
      name === "ModelExam"
    ) {
      if (checked) {
        setTypeOn([...typeOn, { id: value, name: name, type: "type" }]);
      } else {
        setTypeOn(typeOn.filter((item) => item.id !== value));
      }
    } else if (name === "A" || name === "B" || name === "C" || name === "D") {
      if (checked) {
        // setStatus([...status, value]);
        setSection([...section, { id: value, name: name, type: "section" }]);
      } else {
        setSection(section.filter((item) => item.id !== value));
      }
    }
  };

  // handle search function
  const handleSearch = (event) => {
    if (event.key === "Enter") {
      // 👇 Get input value
      let val = event.target.value;
      updateStateData();
      setSearchTerm(val);
      if (val.length > 0) {
        filterSearch = [{ name: "" + val, type: "search" }];
      } else {
        filterSearch = [];
      }
      loadChipdata();
    }
  };

  //-----------search icon handle function
  const handleSearchFocus = () => {
    if (txtBSearch.current) {
      txtBSearch.current.focus();
      const event = new KeyboardEvent("keydown", {
        key: "Enter",
        code: "Enter",
        keyCode: 13,
        which: 13,
        bubbles: true,
      });
      txtBSearch.current.dispatchEvent(event);
    }
  };
  //-------end
  //chip data list view
  const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));

  //chips overall clear button
  const handleAllClear = () => {
    setSearchTerm("");
    setStatus([]);
    setSection([]);
    setUpdateChipData([]);
    setAppOn([]);
    setTypeOn([]);
    setAppData({
      FDate: "",
      TDate: "",
      Days: "",
    });
    setAppOnDue([]);
    // DueData({
    //   FDate: "",
    //   TDate: "",
    //   Days: "",
    // });
    setUpdateListData([]);
  };

  // filter apply button

  const handleApplyFilter = (name) => {
    updateStateData();
    if (name === "status") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        status: false,
      });
    } else if (name === "appliedOn") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        startDate: false,
      });
    } else if (name === "type") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        category: false,
      });
    } else if (name === "section") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        section: false,
      });
    } else if (name === "Due_Date") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        due_date: false,
      });
    }
  };

  //load list data for table
  function loadListdata() {
    let tempstatus = [];
    let temptypeon = [];
    let tempnumstatus = [];
    let tempTypenum = [];
    let tempsection = [];
    status.map((obj) => {
      tempstatus.push(obj.id);
    });
    typeOn.map((obj) => {
      temptypeon.push(obj.id);
    });
    section.map((obj) => {
      tempsection.push(obj.name);
    });

    tempnumstatus = tempstatus.map(Number);

    tempTypenum = temptypeon.map(Number);

    let statusFilter = {
      type: typeOn.length > 0 ? tempTypenum : "",
      status: status.length > 0 ? tempnumstatus : "",
      section: section.length > 0 ? tempsection : "",
      start_date: appOn.length > 0 ? appOn[0].fdate + " 00:00:00" : "",
      end_date: appOn.length > 0 ? appOn[0].edate + " 23:59:00" : "",
      search: searchTerm.length > 0 ? searchTerm : "",
      d_start_date: appOnDue.length > 0 ? appOnDue[0].fdate : "",
      d_end_date: appOnDue.length > 0 ? appOnDue[0].edate : "",
      user_id: userid,
    };
    setIsLoading(true);
    AxiosInstance.post("api/purchase/list", statusFilter)
      .then((res) => {
        if (res.data.status === true) {
          const fiata = res.data.data;
          const serialNumberAddedData = fiata.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));
          // setUpdateListData(fiata);
          setCurrentPage(1);
          const sections = [
            ...new Set(
              res.data.data.map((item) => item.section).filter(Boolean)
            ),
          ];
          setTotalSection(sections);
          setUpdateListData(serialNumberAddedData);
          setRows(serialNumberAddedData);
          setIsLoading(false);
        } else if (res.data.status === false) {
          setUpdateListData([]);
          setRows([]);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setUpdateListData([]);
        setRows([]);
        setIsLoading(false);
        return error;
      });
  }
  //load chip data
  function loadChipdata() {
    //setUpdateChipData([]);
    let tempArr = [];
    // setUpdateChipData(status);
    filterSearch.map((obj) => {
      tempArr.push(obj);
    });
    filterStatus.map((obj) => {
      tempArr.push(obj);
    });

    filterType.map((obj) => {
      tempArr.push(obj);
    });

    filterApplyed.map((obj) => {
      tempArr.push(obj);
    });

    filtersection.map((obj) => {
      tempArr.push(obj);
    });

    filterDueDate.map((obj) => {
      tempArr.push(obj);
    });
    setUpdateChipData(tempArr);
  }
  // applied on handlechange
  const handleAppliedOn = (e) => {
    const { name, value, checked } = e.target;

    if (name === "FDate" || name === "TDate") {
      setAppData((prevState) => {
        const updated = {
          ...prevState,
          [name]: value,
          Days: "", // Reset Days when FDate or TDate is changed
        };

        const from = name === "FDate" ? value : updated.FDate;
        const to = name === "TDate" ? value : updated.TDate;

        if (from && to) {
          const dateRange = `${from} - ${to}`;
          setAppOn([
            {
              name: dateRange,
              fdate: moment(from).format("YYYY-MM-DD"),
              edate: moment(to).format("YYYY-MM-DD"),
              type: "dateRange",
              Days: "",
            },
          ]);
        } else {
          setAppOn([
            {
              name: "",
              fdate: "",
              edate: "",
              type: "dateRange",
              Days: "",
            },
          ]);
        }

        return updated;
      });
    } else if (name === "Days") {
      if (checked) {
        // Set Days and reset FDate/TDate
        setAppData({
          FDate: "",
          TDate: "",
          Days: value,
        });

        const today = new Date();
        let fdate = "";
        let edate = "";
        let label = "";

        if (value === "Today") {
          fdate = edate = moment(today).format("YYYY-MM-DD");
          label = "Today";
        } else if (value === "Yesterday") {
          const yesterday = new Date(today);
          yesterday.setDate(yesterday.getDate() - 1);
          fdate = edate = moment(yesterday).format("YYYY-MM-DD");
          label = "Yesterday";
        } else if (value === "Tweek") {
          const start = moment(today).startOf("week").toDate();
          const end = moment(today).endOf("week").toDate();
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "This week";
        } else if (value === "Lweek") {
          const start = moment(today)
            .subtract(1, "week")
            .startOf("week")
            .toDate();
          const end = moment(today).subtract(1, "week").endOf("week").toDate();
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "Last week";
        } else if (value === "Tmonth") {
          const start = new Date(today.getFullYear(), today.getMonth(), 1);
          const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "This month";
        } else if (value === "Lmonth") {
          const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
          const end = new Date(today.getFullYear(), today.getMonth(), 0);
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "Last month";
        }

        setAppOn([
          {
            name: label,
            fdate,
            edate,
            type: "dayRange",
            Days: value,
          },
        ]);
      }
    }
  };

  // filter clear button
  const handleClear = (name) => {
    updateStateData();
    if (name === "appliedOn") {
      setAppData({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOn([]);
      filterApplyed = [];
      setIsOpen({
        ...isOpen,
        startDate: false,
      });
    } else if (name === "status") {
      // Clear the status array
      setStatus([]);
      filterStatus = [];
      setIsOpen({
        ...isOpen,
        status: false,
      });
    } else if (name === "type") {
      setTypeOn([]);
      filterType = [];
      setIsOpen({
        ...isOpen,
        category: false,
      });
    } else if (name === "section") {
      setSection([]);
      filtersection = [];

      setIsOpen({
        ...isOpen,
        section: false,
      });
    } else if (name === "DueDate") {
      setDueData([]);
      filterDueDate = [];
      setIsOpen({
        ...isOpen,
        due_date: false,
      });
    }
    loadChipdata();
  };

  const handleChangePayNow = (CourseDetail) => {
    navigate(`/PayFee`, {
      state: {
        CourseDetail,
        type_label: 1,
      },
    });
  };

  // //   checking once again  -  handle delete function
  const handleDelete = (chipToDelete, index) => () => {
    updateStateData();
    if (chipToDelete.type === "search") {
      setSearchTerm("");
      filterSearch = [];
    } else if (chipToDelete.type === "status") {
      setStatus(status.filter((item) => item.id !== chipToDelete.id));
      filterStatus = status.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "type") {
      setTypeOn(typeOn.filter((item) => item.id !== chipToDelete.id));
      filterType = typeOn.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "section") {
      setSection(section.filter((item) => item.id !== chipToDelete.id));
      filtersection = section.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "dayRange") {
      setAppData({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOn([]);
      filterApplyed = [];
    } else {
      setAppData({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOn([]);
      filterApplyed = [];
    }
    loadChipdata();
  };

  const handleChangeDate = (date, name) => {
    const dateFilter = moment(date).format("YYYY-MM-DD");

    if (name === "FDate" || name === "TDate") {
      // First, update the date fields and reset Days
      setAppData((prevState) => {
        const updated = {
          ...prevState,
          [name]: dateFilter,
          Days: "", // Reset Days when FDate or TDate is set
        };

        const from = name === "FDate" ? dateFilter : updated.FDate;
        const to = name === "TDate" ? dateFilter : updated.TDate;

        // Only set AppOn if both from and to dates are available
        if (from && to) {
          const dateRange = `${from} - ${to}`;
          setAppOn([
            {
              name: dateRange,
              fdate: moment(from).format("YYYY-MM-DD"),
              edate: moment(to).format("YYYY-MM-DD"),
              type: "dateRange",
              Days: "",
            },
          ]);
        }

        return updated;
      });
    }
  };

  //  filter box tootle function
  const handleFilter = (e, boxName) => {
    if (boxName === "status") {
      setIsOpen((prevState) => ({
        startDate: false,
        section: false,
        category: false,
        due_date: false,
        status: !prevState.status,
      }));
    } else if (boxName === "startDate") {
      setIsOpen((prevState) => ({
        section: false,
        category: false,
        status: false,
        due_date: false,
        startDate: !prevState.startDate,
      }));
    } else if (boxName === "section") {
      setIsOpen((prevState) => ({
        category: false,
        status: false,
        startDate: false,
        due_date: false,
        section: !prevState.section,
      }));
    } else if (boxName === "category") {
      setIsOpen((prevState) => ({
        status: false,
        startDate: false,
        section: false,
        due_date: false,
        category: !prevState.category,
      }));
    } else if (boxName === "due_date") {
      setIsOpen((prevState) => ({
        status: false,
        startDate: false,
        section: false,
        category: false,
        due_date: !prevState.due_date,
      }));
    }
  };

  // total table data  with pages
  const totalPages = Math.ceil(updateListData?.length / rowsPerPage);

  // prev button pagination
  const handlePrev = (val) => {
    setCurrentPage(val);
  };
  // next button pagination
  const handleNext = (val) => {
    setCurrentPage(val);
  };
  // page count handle
  const handlePageCount = (e) => {
    const { name, value, checked } = e.target;
    if (name === "pageCount") {
      setRowsPerPage(parseInt(value));
      setCurrentPage(1);
      setUpdateListData([]);
    }
    loadListdata();
  };
  // pagination start end -   item per page changing
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  const currentData = updateListData.slice(start, end);

  //detail view for this list data
  const handleReadView = (user_id, batch_id, add_id, type) => {
    navigate(
      `/TransactionHistory/ViewAdmission/${user_id}/${batch_id}/${add_id}/${type}/0`,
      {
        state: {
          STATUS: status,
          TYPE: typeOn,
          DATE: appOn,
          SECTION: section,
          SEARCH: searchTerm,
        },
      }
    );
  };

  const fDatePickerRef = useRef(null);
  const tDatePickerRef = useRef(null);
  const filterTypeRef = useRef(null);
  const filterDateRef = useRef(null);
  const filterSectionRef = useRef(null);
  const filterStatusRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        filterTypeRef.current &&
        !filterTypeRef.current.contains(event.target)
      ) {
        const hasType = updateChipData.some(
          (chipItem) => chipItem.type === "type"
        );

        if (hasType) {
          const updatedTypeOn = updateChipData.filter(
            (chipItem) => chipItem.type === "type"
          );

          setTypeOn(updatedTypeOn);
        } else {
          setTypeOn([]);
        }

        setIsOpen((prev) => ({ ...prev, category: false }));
      }
      if (
        filterDateRef.current &&
        !filterDateRef.current.contains(event.target)
      ) {
        const mismatchedDay = updateChipData.find(
          (chipItem) => chipItem.Days && chipItem.Days === appData.Days
        );

        if (mismatchedDay) {
          setAppData({
            FDate: "",
            TDate: "",
            Days: mismatchedDay.Days,
          });
          setAppOn([
            {
              FDate: "",
              TDate: "",
              Days: mismatchedDay.Days,
            },
          ]);
        } else {
          const mismatchedDate = updateChipData.find(
            (chipItem) =>
              chipItem.fdate === appData.FDate &&
              chipItem.edate === appData.TDate
          );

          if (mismatchedDate) {
            setAppData((prev) => ({
              ...prev,
              FDate: mismatchedDate.fdate,
              TDate: mismatchedDate.edate,
              Days: "",
            }));
            setAppOn([
              {
                FDate: mismatchedDate.fdate,
                TDate: mismatchedDate.edate,
                Days: "",
              },
            ]);
          } else {
            setAppData({
              FDate: "",
              TDate: "",
              Days: "",
            });
            setAppOn([]);
          }
        }
        setIsOpen((prev) => ({ ...prev, startDate: false }));
      }

      if (
        filterSectionRef.current &&
        !filterSectionRef.current.contains(event.target)
      ) {
        const hasSection = updateChipData.some(
          (chipItem) => chipItem.type === "section"
        );

        if (hasSection) {
          const updatedSection = updateChipData.filter(
            (chipItem) => chipItem.type === "section"
          );

          setSection(updatedSection);
        } else {
          setSection([]);
        }

        setIsOpen((prev) => ({ ...prev, section: false }));
      }

      if (
        filterStatusRef.current &&
        !filterStatusRef.current.contains(event.target)
      ) {
        const hasStatus = updateChipData.some(
          (chipItem) => chipItem.type === "status"
        );

        if (hasStatus) {
          const updatedStatus = updateChipData.filter(
            (chipItem) => chipItem.type === "status"
          );
          setStatus(updatedStatus);
        } else {
          setStatus([]);
        }

        setIsOpen((prev) => ({ ...prev, status: false }));
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [updateChipData]);

  // collapse row table
  const Row = (props) => {
    const { row, index } = props;
    const [open, setOpen] = React.useState(false);

    return (
      <React.Fragment>
        <TableRow className="" sx={{ "& > *": { borderBottom: "unset" } }}>
          {row.instment_pay && row.instment_pay.length > 0 ? (
            <TableCell>
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => setOpen(!open)}
              >
                {open ? <RemoveCircleRounded /> : <AddCircleRounded />}
              </IconButton>
            </TableCell>
          ) : (
            <TableCell></TableCell>
          )}

          <TableCell component="td" scope="row">
            <span>{row.serialNumber}</span>
          </TableCell>
          <TableCell component="td" id="td" scope="row">
            {row.admission_id}
          </TableCell>
          <TableCell>
            {row.type === 0 && <span>course</span>}
            {row.type === 1 && <span>Test Batch</span>}
            {row.type === 2 && <span>Counselling</span>}
            {row.type === 3 && <span>Special classes</span>}
            {row.type === 4 && <span>Model exam </span>}
            {row.type === 5 && <span>Mock Interview </span>}
          </TableCell>
          <TableCell>{row.batch_name}</TableCell>
          {/* {row.type !== 4 && ( */}
          <TableCell>{row.section ? row.section : "_"}</TableCell>
          {/* )} */}

          <TableCell>{moment(row.applied_on).format("YYYY-MM-DD")}</TableCell>
          <TableCell>₹{row.paid_amount}</TableCell>
          <TableCell>₹{row.balance_amt ? row.balance_amt : 0}</TableCell>
          <TableCell>
            {" "}
            {row.status === 0 && (
              <span className="GreyTexts">WaitForApproval </span>
            )}
            {row.status === 1 && <span className="GreenTexts">Approved</span>}
            {row.status === 2 && <span className="YellowText">OnHold</span>}
            {row.status === 3 && <span className="redText">Rejected </span>}
            {/* {row.status === 4 && <span className="PinkText">Upcoming </span>}
            {row.status === 5 && <span className="GreenText">OnGoing </span>}
            {row.status === 6 && <span className="GreyTexts">completed</span>} */}
          </TableCell>
          <TableCell>
            {" "}
            <button
              className="button"
              onClick={() =>
                handleReadView(row.user_id, row.batch_id, row.adm_pk, row.type)
              }
            >
              <span class="material-icons">visibility</span>
            </button>
          </TableCell>
        </TableRow>
        {row.instment_pay && row.instment_pay.length > 0 && (
          <TableRow id="Subthead">
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <Box sx={{ margin: 1 }}>
                  <Table className="table" id="example" aria-label="purchases">
                    <TableHead>
                      <TableRow>
                        <TableCell id="th">
                          <span
                            className="text_th"
                            onClick={(e) => handleSort(e, "due_amount")}
                          >
                            Amount To Pay
                          </span>
                        </TableCell>
                        <TableCell id="th">
                          <span
                            className="text_th"
                            onClick={(e) => handleSort(e, "paid_date")}
                          >
                            Fees Paid Date
                          </span>
                        </TableCell>
                        <TableCell id="th">
                          <span
                            className="text_th"
                            onClick={(e) => handleSort(e, "due_date")}
                          >
                            Due Date
                          </span>
                        </TableCell>

                        <TableCell id="th">
                          <span
                            className="text_th"
                            onClick={(e) => handleSort(e, "balance_amt")}
                          >
                            Balance Fee
                          </span>
                        </TableCell>
                        <TableCell id="th">
                          <span
                            className="text_th"
                            onClick={(e) => handleSort(e, "payment_status")}
                          >
                            Status
                          </span>

                          {/* <span
                  class="material-icons align-middle"
                  onClick={(e) => handleSort(e, "payment_status")}
                >
                  import_export
                </span> */}
                        </TableCell>
                        <TableCell id="th">
                          <span className="text_th">Action</span>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {row.instment_pay &&
                        row.instment_pay.map((historyRow) => (
                          <TableRow key={historyRow.payment_history_pk}>
                            <TableCell component="td" scope="row">
                              ₹ {historyRow.due_amount}
                            </TableCell>
                            <TableCell>
                              {historyRow.paid_date
                                ? moment(
                                    historyRow.paid_date,
                                    "DD/MM/YYYY",
                                    true
                                  ).isValid()
                                  ? moment(
                                      historyRow.paid_date,
                                      "DD/MM/YYYY"
                                    ).format("YYYY-MM-DD")
                                  : moment(historyRow.paid_date).format(
                                      "YYYY-MM-DD"
                                    )
                                : "_"}
                            </TableCell>
                            <TableCell>
                              {historyRow.due_date
                                ? moment(
                                    historyRow.due_date,
                                    "DD/MM/YYYY",
                                    true
                                  ).isValid()
                                  ? moment(
                                      historyRow.due_date,
                                      "DD/MM/YYYY"
                                    ).format("YYYY-MM-DD")
                                  : moment(historyRow.due_date).format(
                                      "YYYY-MM-DD"
                                    )
                                : ""}
                            </TableCell>
                            <TableCell>
                              ₹
                              {historyRow.balance_amt
                                ? historyRow.balance_amt
                                : 0}
                            </TableCell>
                            <TableCell>
                              {historyRow.payment_status === "0" ? (
                                <button type="button" className="paidcolor">
                                  <Link
                                    className="PyNowBtnLink"
                                    to="javascript:void(0)"
                                  >
                                    Not Paid
                                  </Link>
                                </button>
                              ) : (
                                <button type="button" className="paidcolors">
                                  <Link
                                    className="PyNowBtnLink"
                                    to="javascript:void(0)"
                                  >
                                    Paid
                                  </Link>
                                </button>
                              )}
                            </TableCell>
                            <TableCell>
                              <button
                                type="button"
                                className={
                                  historyRow.payment_status !== "0"
                                    ? "PyNowBtnOP"
                                    : "PyNowBtn"
                                }
                                disabled={historyRow.payment_status !== "0"}
                              >
                                <span class="material-icons">send</span>
                                <Link
                                  className={
                                    historyRow.payment_status !== "0"
                                      ? "PyNowBtnLinkOP"
                                      : "PyNowBtnLink"
                                  }
                                  to={"Javascript:void(0)"}
                                  onClick={() =>
                                    historyRow.payment_status === "0"
                                      ? handleChangePayNow(row)
                                      : ""
                                  }
                                >
                                  Pay Now
                                </Link>
                              </button>
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </Box>
              </Collapse>
            </TableCell>
          </TableRow>
        )}
      </React.Fragment>
    );
  };

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div
      className={
        props.activeTab === 2
          ? "row tab-content mt-4"
          : "row tab-content mt-4 hide "
      }
      id="ex2-content"
    >
      <div
        className={
          props.activeTab === 2
            ? "tab-pane fade show active col-md-12"
            : "tab-pane fade col-md-12 "
        }
      >
        <div className="row mb-3 ms-1">
          <div className="col-lg-12 col-md-12 ps-0">
            <div className="ReViewTableInfo_note h-0">
              <strong> NOTE: </strong> If you wish to settle pending fees with
              cash payment, please visit the office reception and contact the
              finance admin for assistance.
            </div>
          </div>
        </div>
        <div className="row ms-1">
          <div className="col-lg-3 col-md-6 ps-0">
            <div class="input-group">
              <input
                ref={txtBSearch} //new
                type="text"
                class="Inputs"
                id="SearchInput"
                name="SearchInput"
                placeholder="Search by batch"
                onKeyDown={handleSearch}
              />
              <span
                class="input-group-text"
                id="SearchInput"
                onClick={handleSearchFocus}
              >
                <span className="material-icons" onClick={handleSearchFocus}>
                  search
                </span>
              </span>
            </div>
          </div>
          <div className="col-lg-3 col-md-4"></div>
          <div className="col-lg-6  d-flex justify-content-evenly col-md-6"></div>
        </div>
        {updateChipData.length > 0 ? (
          <div className="row mt-3">
            <div className="col-md-12 col-sm-12 col-xs-12 " id="paperil">
              <Paper
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexWrap: "wrap",
                  listStyle: "none",
                  p: 0.5,
                  m: 0,
                }}
                component="ul"
              >
                {updateChipData.map((data, index) => {
                  let icon;
                  let key = "" + data.name;
                  return (
                    <ListItem key={data}>
                      <Chip
                        icon={icon}
                        label={key}
                        onDelete={handleDelete(data, index)}
                      />
                    </ListItem>
                  );
                })}

                <ListItem>
                  {/* <Chip
                      label=" Clear All Filters"
                      onClick={handleAllClear}
                    /> */}
                  <a className="allclear" href="#" onClick={handleAllClear}>
                    Clear All Filters
                  </a>
                </ListItem>
              </Paper>
            </div>
          </div>
        ) : (
          <div></div>
        )}
        <div className="row mt-3 mx-0">
          <div className="col-md-12 table-responsive tableMinHeight p-0 px-0">
            {/* <TableContainer component={Paper}> */}
            <Table
              className="table"
              id="example"
              aria-label="collapsible table"
            >
              <TableHead id="Thead">
                <TableRow>
                  <TableCell />
                  <TableCell id="th">
                    <span
                      className="text_th"
                      onClick={(e) => handleSort(e, "serialNumber")}
                    >
                      S.No
                    </span>
                    <span
                      class="material-icons align-middle"
                      onClick={(e) => handleSort(e, "serialNumber")}
                    >
                      {" "}
                      import_export{" "}
                    </span>
                  </TableCell>
                  <TableCell id="th">
                    {" "}
                    <span
                      className="text_th"
                      onClick={(e) => handleSort(e, "admission_id")}
                    >
                      {" "}
                      Admission ID
                    </span>
                    <span
                      class="material-icons align-middle"
                      onClick={(e) => handleSort(e, "admission_id")}
                    >
                      {" "}
                      import_export{" "}
                    </span>
                  </TableCell>

                  <TableCell id="th">
                    <span
                      className="text_th"
                      // onClick={(e) => handleSort(e, "type")}
                    >
                      Type
                    </span>
                    {/* <span
                        class="material-icons align-middle"
                        onClick={(e) => handleSort(e, "type")}
                      >
                        {" "}
                        import_export{" "}
                      </span>{" "} */}
                    <span
                      class={`align-middle material-icons ${
                        typeOn.length > 0 || isOpen.category
                          ? "active_icons"
                          : ""
                      }`}
                      onClick={(e) => handleFilter(e, "category")}
                    >
                      filter_list
                    </span>
                    {isOpen.category === true && (
                      <div className="filterBoxTwo p-1" ref={filterTypeRef}>
                        <div className="row mt-2">
                          <div className="col-md-12">
                            <div class="form-check ms-3">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                name="course"
                                value="0"
                                checked={typeOn.some((element) => {
                                  if (element.id === "0") {
                                    return true;
                                  }
                                  return false;
                                })}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "course")
                                }
                                id="course"
                              />
                              <label
                                class="form-check-label pb-0 pt-0 align-top YellowText"
                                for="defaultCheck1"
                                htmlFor="course"
                              >
                                Course
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-12">
                            <div class="form-check ms-3">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                name="TestBatch"
                                value="1"
                                checked={typeOn.some((element) => {
                                  if (element.id === "1") {
                                    return true;
                                  }
                                  return false;
                                })}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "TestBatch")
                                }
                                id="TestBatch"
                              />
                              <label
                                class="form-check-label pb-0 pt-0 align-top GreenText"
                                for="defaultCheck1"
                                htmlFor="TestBatch"
                              >
                                Test Batch
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-12">
                            <div class="form-check ms-3">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                name="SpecialClass"
                                value="3"
                                checked={typeOn.some((element) => {
                                  if (element.id === "3") {
                                    return true;
                                  }
                                  return false;
                                })}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "SpecialClass")
                                }
                                id="SpecialClass"
                              />
                              <label
                                class="form-check-label pb-0 pt-0 align-top  YellowText"
                                for="defaultCheck1"
                                htmlFor="SpecialClass"
                              >
                                Special Class
                              </label>
                            </div>
                          </div>
                        </div>

                        <div className="row mt-3">
                          <div className="col-md-12">
                            <div class="form-check ms-3">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                name="Counselling"
                                value="2"
                                checked={typeOn.some((element) => {
                                  if (element.id === "2") {
                                    return true;
                                  }
                                  return false;
                                })}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "Counselling")
                                }
                                id="Counselling"
                              />
                              <label
                                class="form-check-label pb-0 align-top pt-0 RedText"
                                for="defaultCheck1"
                                htmlFor="Counselling"
                              >
                                Counselling
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-12">
                            <div class="form-check ms-3">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                name="MockInterview"
                                value="5"
                                checked={typeOn.some((element) => {
                                  if (element.id === "5") {
                                    return true;
                                  }
                                  return false;
                                })}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "MockInterview")
                                }
                                id="MockInterview"
                              />
                              <label
                                class="form-check-label pb-0 align-top pt-0 RedText"
                                for="defaultCheck1"
                                htmlFor="MockInterview"
                              >
                                Mock Interview
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-12">
                            <div class="form-check ms-3">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                name="ModelExam"
                                value="4"
                                checked={typeOn.some((element) => {
                                  if (element.id === "4") {
                                    return true;
                                  }
                                  return false;
                                })}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "ModelExam")
                                }
                                id="ModelExam"
                              />
                              <label
                                class="form-check-label pb-0 align-top pt-0 RedText"
                                for="defaultCheck1"
                                htmlFor="ModelExam"
                              >
                                Model Exam
                              </label>
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div className="row mt-3">
                          <div className="col-md-4  col-4 col-sm-4">
                            <span
                              className="clearFilter ms-2 "
                              style={{ cursor: "pointer" }}
                              onClick={() => handleClear("type")}
                            >
                              Clear
                            </span>
                          </div>
                          <div className="col-md-8  col-8 col-sm-8">
                            <button
                              className="FilterButton"
                              disabled={typeOn.length === 0 ? true : false}
                              onClick={() => handleApplyFilter("type")}
                            >
                              Apply Filter
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </TableCell>

                  <TableCell id="th">
                    <span
                      className="text_th"
                      onClick={(e) => handleSort(e, "batch_name")}
                    >
                      Batch
                    </span>
                    <span
                      class="material-icons align-middle"
                      onClick={(e) => handleSort(e, "batch_name")}
                    >
                      import_export
                    </span>
                  </TableCell>
                  {/* {rows.map((el) => el.type !== 4 && ( */}

                  <TableCell id="th">
                    <span
                      className="text_th"
                      onClick={(e) => handleSort(e, "section")}
                    >
                      Section
                    </span>
                    <span
                      class="material-icons align-middle"
                      onClick={(e) => handleSort(e, "section")}
                    >
                      import_export
                    </span>{" "}
                    <span
                      class={`align-middle material-icons ${
                        section.length > 0 || isOpen.section
                          ? "active_icons"
                          : ""
                      }`}
                      onClick={(e) => handleFilter(e, "section")}
                    >
                      filter_list
                    </span>
                    {isOpen.section === true && (
                      <div className="filterBoxs p-1" ref={filterSectionRef}>
                        <div className="row mt-4">
                          {totalSection.map((sectionName, index) => (
                            <div className="col-md-3" key={index}>
                              <div className="form-check ms-2">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  name={sectionName}
                                  value={sectionName}
                                  id={sectionName}
                                  checked={section.some(
                                    (element) => element.name === sectionName
                                  )}
                                  onChange={(e) =>
                                    handleCheckboxChange(e, sectionName)
                                  }
                                />
                                <label
                                  class="form-check-label "
                                  for="defaultCheck1"
                                  htmlFor={sectionName}
                                  style={{ marginTop: "-2px" }}
                                >
                                  {sectionName}
                                </label>
                              </div>
                            </div>
                          ))}
                        </div>
                        <hr />
                        <div className="row mt-3">
                          <div className="col-md-4 col-4 col-sm-4">
                            <span
                              className="clearFilter ms-2"
                              style={{ cursor: "pointer" }}
                              onClick={() => handleClear("section")}
                            >
                              Clear
                            </span>
                          </div>
                          <div className="col-md-8 col-8 col-sm-8">
                            <button
                              className="FilterButton"
                              onClick={() => handleApplyFilter("section")}
                            >
                              Apply Filter
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </TableCell>
                  {/* // )) }  */}

                  <TableCell id="th">
                    <span
                      className="text_th"
                      onClick={(e) => handleSort(e, "applied_on")}
                    >
                      Applied On
                    </span>
                    <span
                      class="material-icons align-middle"
                      onClick={(e) => handleSort(e, "applied_on")}
                    >
                      import_export
                    </span>{" "}
                    <span
                      onClick={(e) => handleFilter(e, "startDate")}
                      class={`align-middle material-icons ${
                        (appData &&
                          Object.entries(appData).some(
                            ([key, val]) =>
                              key !== "name" &&
                              val !== null &&
                              val !== undefined &&
                              val.toString().trim() !== ""
                          )) ||
                        isOpen.startDate
                          ? "active_icons"
                          : ""
                      }`}
                    >
                      filter_list
                    </span>
                    {isOpen.startDate === true && (
                      <div
                        className="filterBoxOne container p-1"
                        ref={filterDateRef}
                      >
                        <div className="row mt-1">
                          <div className="col-md-12">
                            <div class="form-check p-1">
                              <label
                                htmlFor="FDate"
                                className="d-flex form-label"
                              >
                                From Date
                                <span
                                  data-required="true"
                                  aria-hidden="true"
                                ></span>
                              </label>
                              <DatePickerSample
                                IconInput={"filterIocnBoxInput"}
                                class={"FilterInputs"}
                                name={"FDate"}
                                handleChange={handleChangeDate}
                                fieldInput={appData.FDate}
                                txtAdMDob={fDatePickerRef}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row mt-1">
                          <div className="col-md-12">
                            <div class="form-check p-1">
                              <label
                                htmlFor="TDate "
                                className="d-flex form-label"
                              >
                                To Date
                                <span
                                  data-required="true"
                                  aria-hidden="true"
                                ></span>
                              </label>

                              <DatePickerSample
                                class={"FilterInputs"}
                                IconInput={"filterIocnBoxInput"}
                                name={"TDate"}
                                handleChange={handleChangeDate}
                                fieldInput={appData.TDate}
                                txtAdMDob={tDatePickerRef}
                                minDate={appData.FDate}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                            <div class="form-check">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="Days"
                                id="Today"
                                value="Today"
                                checked={appData.Days === "Today"}
                                onChange={handleAppliedOn}
                              />
                              <label
                                class="form-check-label d-flex"
                                for="Today"
                                htmlFor="Today"
                                style={{ fontWeight: "bold" }}
                              >
                                Today
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                            <div class="form-check">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="Days"
                                value="Yesterday"
                                checked={appData.Days === "Yesterday"}
                                id="Yesterday"
                                onChange={handleAppliedOn}
                              />
                              <label
                                class="form-check-label d-flex"
                                for="Yesterday"
                                htmlFor="Yesterday"
                                style={{ fontWeight: "bold" }}
                              >
                                Yesterday
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                            <div class="form-check">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="Days"
                                value="Tweek"
                                checked={appData.Days === "Tweek"}
                                id="Tweek"
                                onChange={handleAppliedOn}
                              />
                              <label
                                class="form-check-label d-flex"
                                for="Tweek"
                                htmlFor="Tweek"
                                style={{ fontWeight: "bold" }}
                              >
                                This week
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                            <div class="form-check">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="Days"
                                value="Lweek"
                                checked={appData.Days === "Lweek"}
                                id="Lweek"
                                onChange={handleAppliedOn}
                              />
                              <label
                                class="form-check-label d-flex"
                                for="Lweek"
                                htmlFor="Lweek"
                                style={{ fontWeight: "bold" }}
                              >
                                Last week
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                            <div class="form-check">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="Days"
                                value="Tmonth"
                                checked={appData.Days === "Tmonth"}
                                id="Tmonth"
                                onChange={handleAppliedOn}
                              />
                              <label
                                class="form-check-label d-flex"
                                for="Tmonth"
                                htmlFor="Tmonth"
                                style={{ fontWeight: "bold" }}
                              >
                                This month
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                            <div class="form-check">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="Days"
                                checked={appData.Days === "Lmonth"}
                                value="Lmonth"
                                id="Lmonth"
                                onChange={handleAppliedOn}
                              />
                              <label
                                class="form-check-label d-flex"
                                for="Lmonth"
                                htmlFor="Lmonth"
                                style={{ fontWeight: "bold" }}
                              >
                                Last month
                              </label>
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div className="row mt-3">
                          <div className="col-md-4  col-4 col-sm-4">
                            <span
                              className="clearFilter ms-2 "
                              style={{ cursor: "pointer" }}
                              onClick={() => handleClear("appliedOn")}
                            >
                              Clear
                            </span>
                          </div>
                          <div className="col-md-8  col-8 col-sm-8">
                            <button
                              className="FilterButton"
                              onClick={() => handleApplyFilter("appliedOn")}
                            >
                              Apply Filter
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </TableCell>
                  <TableCell id="th">
                    <span
                      className="text_th"
                      onClick={(e) => handleSort(e, "paid_amount")}
                    >
                      Fees Paid
                    </span>

                    <span
                      class="material-icons align-middle"
                      onClick={(e) => handleSort(e, "paid_amount")}
                    >
                      import_export
                    </span>
                  </TableCell>
                  <TableCell id="th">
                    <span
                      className="text_th"
                      onClick={(e) => handleSort(e, "balance_amt")}
                    >
                      Balance Fee
                    </span>

                    <span
                      class="material-icons align-middle"
                      onClick={(e) => handleSort(e, "balance_amt")}
                    >
                      import_export
                    </span>
                  </TableCell>
                  <TableCell id="th">
                    <span
                      className="text_th"
                      onClick={(e) => handleSort(e, "status")}
                    >
                      Status
                    </span>

                    {/* <span
                        class="material-icons align-middle"
                        onClick={(e) => handleSort(e, "status")}
                      >
                        import_export
                      </span>{" "} */}
                    <span
                      class={`align-middle material-icons ${
                        status.length > 0 || isOpen.status ? "active_icons" : ""
                      }`}
                      onClick={(e) => handleFilter(e, "status")}
                    >
                      filter_list
                    </span>
                    {isOpen.status === true && (
                      <div className="filterBoxs p-1" ref={filterStatusRef}>
                        <div className="row mt-2">
                          <div className="col-md-12">
                            <div class="form-check ms-3">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                name="WaitForApproval"
                                value="0"
                                id="WaitForApproval"
                                checked={status.some((element) => {
                                  if (element.id === "0") {
                                    return true;
                                  }
                                  return false;
                                })}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "WaitForApproval")
                                }
                              />
                              <label
                                class="form-check-label GreyText"
                                for="defaultCheck1"
                                htmlFor="WaitForApproval"
                              >
                                WaitForApproval
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-md-12">
                            <div class="form-check ms-3">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                name="Rejected"
                                value="3"
                                id="Rejected"
                                checked={status.some((element) => {
                                  if (element.id === "3") {
                                    return true;
                                  }
                                  return false;
                                })}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "Rejected")
                                }
                              />
                              <label
                                class="form-check-label redText"
                                for="defaultCheck1"
                                htmlFor="Rejected"
                              >
                                Rejected
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-md-12">
                            <div class="form-check ms-3">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                name="OnHold"
                                value="2"
                                id="OnHold"
                                checked={status.some((element) => {
                                  if (element.id === "2") {
                                    return true;
                                  }
                                  return false;
                                })}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "OnHold")
                                }
                              />
                              <label
                                class="form-check-label YellowText"
                                for="defaultCheck1"
                                htmlFor="OnHold"
                              >
                                OnHold
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-md-12">
                            <div class="form-check ms-3">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                name="Approved"
                                value="1"
                                id="Approved"
                                checked={status.some((element) => {
                                  if (element.id === "1") {
                                    return true;
                                  }
                                  return false;
                                })}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "Approved")
                                }
                              />
                              <label
                                class="form-check-label GreenText"
                                for="defaultCheck1"
                                htmlFor="Approved"
                              >
                                Approved
                              </label>
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div className="row mt-3">
                          <div className="col-md-4  col-4 col-sm-4">
                            <span
                              className="clearFilter ms-2 "
                              style={{ cursor: "pointer" }}
                              onClick={() => handleClear("status")}
                            >
                              Clear
                            </span>
                          </div>
                          <div className="col-md-8  col-8 col-sm-8">
                            <button
                              className="FilterButton"
                              onClick={() => handleApplyFilter("status")}
                            >
                              Apply Filter
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </TableCell>
                  <TableCell id="th">
                    {" "}
                    <span className="text_th">Action</span>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.length === 0 ? (
                  <tr>
                    <td colspan="12" style={{ textAlign: "center" }}>
                      No records to display
                    </td>
                  </tr>
                ) : (
                  currentData.map((row, index) => (
                    <Row key={row.admission_id} row={row} index={index} />
                  ))
                )}
              </TableBody>
            </Table>
            {/* </TableContainer> */}
          </div>
        </div>
        <div className="row mt-3 ms-1 me-1">
          <div className="col-md-12">
            <div className="pag w-100 dflexcenter">
              <span className="ipage">Items Per Page</span>
              <select
                name="pageCount"
                id="pageCount"
                defaultValue={rowsPerPage}
                onChange={handlePageCount}
                className="ms-2"
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
              <span className="pagenumber ms-2">
                {" "}
                {updateListData.length > 0
                  ? currentPage * rowsPerPage + 1 - rowsPerPage
                  : 0}{" "}
                -
                {updateListData.length < currentPage * rowsPerPage
                  ? updateListData.length
                  : currentPage * rowsPerPage}{" "}
                of {updateListData.length}
              </span>
              <button
                className="prev_button ms-2 me-2"
                onClick={(e) => handlePrev(currentPage - 1)}
                disabled={currentPage === 1}
              >
                <span class="material-icons">chevron_left</span>
              </button>
              <button
                className="prev_button"
                onClick={() => handleNext(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                <span class="material-icons">chevron_right</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdmissionPurchase;
